// extracted by mini-css-extract-plugin
module.exports = {"integral-goods-pictrue":"integral-goods-pictrue-e71daa51ad9660518df2f7f5b543f105","pt-integral-goods-table":"pt-integral-goods-table-23657753be55945c9418d7e36104fb22"};